export default __webpack_public_path__ + "static/media/2.fc42a304.jpg";